<div class="ir-item-line th-filter">
  <div (click)="setOrderBy('name')" class="ir-item-cell s4 clickable active">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('status')" class="ir-item-cell s2 clickable active">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.status' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('generationDate')" class="ir-item-cell s2 clickable active">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'inspections.reports.generation-date' | translate }}
    </span>
  </div>
  <div class="ir-item-cell s2 clickable active right">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'inspections.reports.exports' | translate }}
    </span>
  </div>
</div>
<div class="ir-content-flow has-filter">
  <div
    class="ir-item-line th-inspection"
    [class.new-report]="report.isNew"
    *ngFor="let report of reports | orderBy : orderByFieldName : direction | searchBy : query"
  >
    <div class="ir-item-cell s4">
      <span>{{ report?.name }}</span>
    </div>
    <div class="ir-item-cell s2">
      <span>{{ report?.status | reportstatus }}</span>
    </div>
    <div class="ir-item-cell s2">
      <span>{{ report?.generationDate | formatDate }} {{ report?.generationDate | date : 'HH:mm' }}</span>
    </div>
    <div class="ir-item-cell s2 right strong exports">
      <ng-container *ngFor="let item of report.items">
        <i [title]="'inspections.reports.report-300.name' | translate" class="material-icons" *ngIf="item.status === 200 && item.type === 300" (click)="downloadReport(item)">build</i>
        <i [title]="'inspections.reports.report-100.name' | translate" class="material-icons internal" *ngIf="item.status === 200 && item.type === 100" (click)="downloadReport(item)">assignment_ind</i>
        <i [title]="'inspections.reports.report-200.name' | translate" class="material-icons" *ngIf="item.status === 200 && item.type === 200" (click)="downloadReport(item)">assignment_late</i>
        <i [title]="'inspections.reports.report-500.name' | translate" class="material-icons internal" *ngIf="item.status === 200 && item.type === 500" (click)="downloadReport(item)">build</i>
        <i [title]="'inspections.reports.report-400.name' | translate" class="material-icons" *ngIf="sendReport && item.status === 200 && item.type === 400" (click)="shareReport(report)">mail</i>
        <i [title]="'inspections.reports.report-50.name' | translate" class="material-icons" *ngIf="item.status === 200 && item.type === 50" (click)="downloadReport(item)">credit_card_off</i>
      </ng-container>
    </div>
  </div>
  <div class="ir-item-empty ir-mv8" *ngIf="reports?.length == 0">
    <p>
      <span>{{ 'inspections.reports.no-reports' | translate }}</span>
    </p>
  </div>
</div>
<!-- End content flow -->
